import { render } from "./Vnud-Typography.vue?vue&type=template&id=9e3fad7c"
import script from "./Vnud-Typography.vue?vue&type=script&lang=js"
export * from "./Vnud-Typography.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Plataforma_eventos\\registar-evento\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__